var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmissions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8032 22.7503C20.0622 22.7623 19.4722 23.0793 19.4732 23.4673L21.5522 26.5113H3.10617C2.20717 26.5113 1.25217 26.5803 1.47117 27.3663C1.69017 28.1523 7.61717 35.3203 7.82617 35.6433C8.14017 36.1273 8.56217 36.4983 9.46117 36.4983L23.4102 36.6453C23.4102 36.6453 26.2692 39.1133 26.5692 39.4123C26.8692 39.7113 27.1832 40.1293 27.9412 40.1293C28.2982 40.1293 28.8422 39.9403 29.0492 39.7993C29.1892 39.7043 39.6772 31.0883 39.6772 31.0883C40.2202 30.8123 37.9092 26.6763 37.3812 26.3923C37.3722 26.3873 37.3622 26.3823 37.3532 26.3773L21.8002 22.9523C21.5342 22.8173 21.1742 22.7443 20.8042 22.7493L20.8032 22.7503Z",
    fill: "#172535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1531 15.5571C27.4121 15.5741 26.8221 16.0301 26.8231 16.5861V21.0471H11.0881C10.1891 21.0471 9.45312 21.5991 9.45312 22.2751V33.5461C9.45312 34.2211 10.1891 34.7741 11.0881 34.7741H26.8241V39.2351C26.8241 39.8041 27.4381 40.2641 28.1961 40.2641C28.5531 40.2641 28.8951 40.1601 29.1511 39.9731L44.6931 28.6491C45.2361 28.2531 45.2491 27.6011 44.7211 27.1931C44.7121 27.1861 44.7021 27.1791 44.6931 27.1721L29.1511 15.8481C28.8851 15.6541 28.5251 15.5491 28.1551 15.5571H28.1531Z",
    fill: "#FD6A3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmissions);
export default __webpack_public_path__ + "static/media/submissions.fff75041b47f215515d575f10b75a502.svg";
export { ForwardRef as ReactComponent };